export default {
  nl: {
    coach: "Coach",
    greeting: "Dag",
    myProgram: "Mijn Programma",
    myProgramStopped: "Mijn Programma - Stopgezet",
    programType: "Type",
    programFormula: "Formule",
    programStartedOn: "Gestart op",
    programPhase: "Fase",
    hour: "uur",
    date: "Datum",
    numberOfHours: "Aantal uur",
    comment: "Opmerking",
    commentRequired: "Opmerking is verplicht",
    confirmedByYou: "Bevestigd door jou",
    youNotPresent: "Je was niet aanwezig",
    participantPresent: "Deelnemer aanwezig",
    requiresParticipantConfirmation: "Vereist deelnemersbevestiging",
    yourCoach: "Jouw coach",
    confirmActivityButton: "Bevestig activiteit",
    confirmActivityMissingId: "Deze bevestigingslink is ongeldig.",
    confirmActivityNotFound: "Deze activiteit werd niet gevonden.",
    confirmActivityLoadError: "De activiteit kon niet geladen worden. Probeer opnieuw via de link in de e-mail.",
    confirmActivityConfirmError: "Bevestigen is mislukt. Probeer opnieuw.",
    notAssignedToProgram:
      "Je bent nog niet gekoppeld aan een programma. Later zal je hier meer informatie vinden over je programma.",
    explanationActivitiesParticipant:
      "Bekijk en bevestig hier je activiteiten voor deze fase.",
    activePrograms: "Actieve programmas",
    view: "Bekijk",
    program: "Programma",
    status: "Status",
    stop: "Onderbreken",
    restart: "Hervatten",
    participant: "Deelnemer",
    program_states: "Gebeurtenissen programma",
    edit: "Bewerken",
    signout: 'Afmelden',
    yes: 'Ja',
    no: 'Nee',
    activityConfirmed: 'Activiteit bevestigd',
    confirmationSkippedByCoach: 'Bevestiging overgeslagen door coach',
    addActivity: 'Toevoegen',
    plannedStartDate: 'Geplande startdatum',
    active: 'Lopend',
    suspended: 'Onderbroken',
    archived: 'Gearchiveerd',
    noExtraInfo: 'Geen extra info',
    fullName: 'Volledige naam',
    created: 'Aangemaakt',
    resumed: 'Hervat',
    started: 'Gestart',
    completed: 'Afgerond',
    notCompleted: 'Niet afgerond',
    unknownStatus: 'Onbekende status',
    time: 'Tijdstip',
    details: 'Details',
    cancel: 'Annuleer',
    back: 'Terug',
    next: 'Volgende',
    confirm: 'Bevestig',
    numerOfHours: 'Aantal uur',
    numberOfMinutes: 'Aantal minuten',
    delete: 'Verwijderen',
    save: 'Opslaan',
    deleted: 'Verwijderd',
    archive: 'Archiveren',
    deArchive: 'Dearchiveren',
    on: 'Op',
    resume: 'Hervatten',
    emailOnActivityCreation: 'Email bij het aanmaken van een activiteit',
    accountSettings: 'Accountinstellingen',
    assignedContent: 'Toegewezen content',
    noContent: 'Geen content',
    assign: 'Toewijzen',
    content: 'Content',
    inscriptions: 'Inschrijvingen',
    meeting: 'Vergadering',
    assignments: 'Toewijzingen',
    noInscriptions: "Nog geen inschrijvingen",
    addParticipant: 'Deelnemer inschrijven',
    givenBy: 'Gegeven door',
    register: 'inschrijven',
    registered: 'Ingeschreven',
    participantReigstered: 'Participant inscrit',
    participantRegistered: 'Deelnemer ingeschreven',
    communication: 'Communicatie',
    attachments: 'Bijlagen',
    send: 'Verzenden',
    message: 'Bericht',
    communicationSent: 'Communicatie verzonden',
    communicationRecipients: 'Verzenden naar',
    sendToAllParticipants: 'Alle ingeschreven deelnemers',
    sendToPresentParticipants: 'Enkel aanwezige deelnemers',
    noCommunicationRecipients: 'Geen ontvangers geselecteerd',
    noActualActivitries: 'Geen activiteiten voor deze fase',
    participantAlreadyRegistered: 'Deze deelnemer is al ingeschreven',
    noWebinars: 'Geen ingeschreven webinars',
    addScreenCast: 'Voeg screencast toe',
    noScreenScasts: 'Geen screencasts toegevoegd',
    browseScreencasts: 'Bekijk Screencasts',
    browseScreencastsDescription: 'Bekijk alle beschikbare screencasts in jouw taal',
    viewScreencasts: 'Bekijk Screencasts',
    screencasts: 'Screencasts',
    screencastsBrowseDescription: 'Blader door beschikbare screencasts in jouw taal',
    noScreencastsAvailable: 'Geen screencasts beschikbaar in jouw taal',
    allScreencasts: 'Alle screencasts',
    allScreencastsDescription: 'Bekijk alle beschikbare screencasts',
    coachTip: 'Tip van coach',
    coachTipDescription: 'Content toegewezen door jouw coach',
    noCoachTipYet: 'Je coach heeft nog geen content toegewezen',
    myWebinars: 'Mijn webinars',
    myWebinarsDescription: 'Webinars waarvoor je bent ingeschreven',
    noRegisteredWebinars: 'Je bent nog niet ingeschreven voor webinars',
    noUpcomingRegisteredWebinars: 'Geen aankomende webinars',
    pastWebinars: 'Afgelopen webinars',
    upcomingWebinars: 'Aankomende webinars',
    upcomingWebinarsDescription: 'Alle beschikbare webinars',
    noUpcomingWebinars: 'Geen aankomende webinars gepland',
    pastEvent: 'Afgelopen',
    loading: 'Laden',
    search: 'Zoeken',
    total: 'Totaal',
    progress: 'Voortgang',
    copyToClipboard: 'Kopieer naar klembord',
    copiedToClipboard: 'Gekopieerd naar klembord',
    webinarEnded: 'Webinar afgelopen',
    surveySent: 'Enquête verzonden',
    toConfirm: 'Te bevestigen',
    participantConfirmed: 'Deelnemer bevestigd',
    note: 'Notitie',
    library: 'Bibliotheek',
    manualCoach: 'Handleiding coaches',
    manualParticipant: 'Handleiding deelnemers',
    skipActivityReminders: 'Activiteit herinneringen overslaan',
    loginCheckManual: 'Bekijk ook de',
    loginManual: 'handleiding',
    loginProblems: 'Ondervind je problemen of heb je vragen?',
    loginContactUs: 'Contacteer ons.',
    loginPassword: 'Paswoord',
    loginForgotPassword: 'Paswoord vergeten?',
    loginEmailSent: 'Email verzonden',
    loginClickLink: 'Klik op de link in de email om in te loggen.',
    loginEmailFrom: 'Email afkomstig van: no-reply@itinera-talentcoaching.be (check ook je spam)',
    loginErrorGeneric: 'Er is iets misgelopen, probeer opnieuw.',
    loginErrorNoUser: 'Er is geen gebruiker met dit email adres gevonden.',
    loginAccountArchived: 'Je traject bij Itinera is afgerond en je dossier werd afgesloten. Inloggen op de Itinera Hub is daarom niet meer mogelijk. Neem contact op met je coach als je nog vragen hebt.',
    loginLinkExpired: 'Deze inloglink is verlopen of werd al gebruikt. Vul hieronder je email adres in om een nieuwe link te ontvangen.',
    loginLinkWrongEmail: 'Dit email adres komt niet overeen met het adres waarnaar de inloglink werd verstuurd. Probeer opnieuw.',
    loginLinkEnterEmail: 'Bevestig je email adres om het inloggen te voltooien.',
    loginLinkConfirm: 'Inloggen',
    loginWrongPassword: 'Het paswoord is niet correct.',
    programArchivedNoAccess: 'Dit dossier is gearchiveerd en is enkel nog beschikbaar voor administrators.',
    backToOverview: 'Terug naar overzicht',
    backToHome: 'Terug naar Home',
    viewAgain: 'Opnieuw bekijken',
    totalOverview: 'Totaal overzicht',
    activities: 'Activiteiten',
    directlyCounted: 'Direct geteld',
    planned: 'Gepland',
    performed: 'Gepresteerd',
    confirmed: 'Bevestigd',
    registerForWebinar: 'Inschrijven',
    registeredForWebinar: 'Ingeschreven voor webinar',
    webinarTypeExplanationOM: 'OM = Organisatorisch Management\nDeze webinar richt zich op deelnemers met een leidinggevende, coördinerende of strategische functie.',
    webinarTypeExplanationOT: 'OT = Operationeel Technisch\nDeze webinar richt zich op deelnemers met een uitvoerende, technische of operationele functie.',
    webinarTypeExplanationQuestion: 'Twijfel je welke optie het best bij jou past? Bespreek dit gerust met je coach.',
  },
  fr: {
    coach: "Coach",
    yourCoach: "Votre coach",
    confirmActivityButton: "Confirmer",
    confirmActivityMissingId: "Ce lien de confirmation n'est pas valide.",
    confirmActivityNotFound: "Cette activité est introuvable.",
    confirmActivityLoadError: "Impossible de charger l'activité. Réessayez via le lien dans l'e-mail.",
    confirmActivityConfirmError: "La confirmation a échoué. Veuillez réessayer.",
    greeting: "Bonjour",
    myProgram: "Mon Programme",
    myProgramStopped: "Mon Programme - Arrêté",
    programType: "Type",
    programFormula: "Formule",
    programStartedOn: "Commencé le",
    programPhase: "Phase",
    hour: "heure",
    date: "Date",
    numberOfHours: "Nombre d'heures",
    comment: "Note",
    commentRequired: "La note est obligatoire",
    confirmedByYou: "Confirmer",
    youNotPresent: "Vous n'étiez pas présent",
    notAssignedToProgram: "Vous n'êtes pas encore lié à un programme.",
    explanationActivitiesParticipant:
      "Consultez et confirmez vos activités pour cette pahase ici.",
    activePrograms: "Programmes actifs",
    view: "Plus d'infos",
    program: "Programme",
    status: "Statut",
    stop: "Suspendre",
    restart: "Résumér",
    participant: "Participant",
    program_states: "Événements du programme",
    participantPresent: "Participant présent",
    requiresParticipantConfirmation: "Nécessite la confirmation du participant",
    browseScreencasts: 'Consulter les Screencasts',
    browseScreencastsDescription: 'Voir tous les screencasts disponibles dans votre langue',
    viewScreencasts: 'Voir les Screencasts',
    screencasts: 'Screencasts',
    screencastsBrowseDescription: 'Parcourir les screencasts disponibles dans votre langue',
    noScreencastsAvailable: 'Aucun screencast disponible dans votre langue',
    allScreencasts: 'Tous les screencasts',
    allScreencastsDescription: 'Voir tous les screencasts disponibles',
    coachTip: 'Conseil du coach',
    coachTipDescription: 'Contenu attribué par votre coach',
    noCoachTipYet: 'Votre coach n\'a pas encore attribué de contenu',
    myWebinars: 'Mes webinaires',
    myWebinarsDescription: 'Webinaires auxquels vous êtes inscrit',
    noRegisteredWebinars: 'Vous n\'\u00eates pas encore inscrit à des webinaires',
    noUpcomingRegisteredWebinars: 'Aucun webinaire à venir',
    pastWebinars: 'Webinaires passés',
    upcomingWebinars: 'Webinaires à venir',
    upcomingWebinarsDescription: 'Tous les webinaires disponibles',
    noUpcomingWebinars: 'Aucun webinaire à venir prévu',
    pastEvent: 'Passé',
    loading: 'Chargement',
    edit: "Modifier",
    signout: 'Déconnecter',
    yes: 'Oui',
    no: 'Non',
    activityConfirmed: 'Activité confirmée',
    confirmationSkippedByCoach: 'Confirmation ignorée par le coach',
    addActivity: 'Ajouter une activité',
    plannedStartDate: 'Date de début prévue',
    active: 'Actif',
    suspended: 'Interrompu',
    archived: 'Archivé',
    noExtraInfo: 'Pas d\'informations supplémentaires',
    fullName: 'Nom complet',
    created: 'Créé',
    resumed: 'Redémarré',
    started: 'Démarré',
    completed: 'Complété',
    notCompleted: 'Non complété',
    unknownStatus: 'Statut inconnu',
    time: 'Temps',
    details: 'Details',
    cancel: 'Annuler',
    back: 'Retourner',
    next: 'continuer',
    confirm: 'Confirmer',
    numerOfHours: "Nombre d'heures",
    numberOfMinutes: 'Nombre de minutes',
    delete: 'Supprimer',
    save: 'Sauvez',
    deleted: 'Supprimé',
    archive: 'Archive',
    deArchive: 'Désarchivage',
    on: 'a',
    resume: 'redémarrer',
    emailOnActivityCreation: "Courriel lors de la création d'une activité",
    accountSettings: 'Paramètres du compte',
    assignedContent: 'Contenu attribué',
    noContent: 'Pas de contenu',
    assign: 'Attribuer',
    content: 'contenu',
    inscriptions: 'Entrées',
    meeting: 'réunion',
    assignments: 'Allocations',
    noInscriptions: "Pas encore d'inscriptions",
    addParticipant: 'Enregistrer un participant',
    givenBy: 'Donné par',
    register: 'registre',
    registered: 'Inscrit',
    participantReigstered: 'Participant inscrit',
    participantRegistered: 'Participant inscrit',
    communication: 'Communication',
    attachments: 'Pièces jointes',
    send: 'Envoyer',
    message: 'Message',
    communicationSent: 'Communication envoyée',
    communicationRecipients: 'Envoyer à',
    sendToAllParticipants: 'Tous les participants inscrits',
    sendToPresentParticipants: 'Uniquement les participants présents',
    noCommunicationRecipients: 'Aucun destinataire sélectionné',
    noActualActivitries: 'Pas d\'activités pour cette phase',
    participantAlreadyRegistered: 'Ce participant est déjà inscrit',
    noWebinars: 'Pas de webinaires inscrits',
    addScreenCast: 'Ajouter un screencast',
    noScreenScasts: 'Aucun screencast ajouté',
    search: 'Chercher',
    total: 'Total',
    progress: 'Progression',
    copyToClipboard: 'Copier dans le presse-papiers',
    copiedToClipboard: 'Copié dans le presse-papiers',
    webinarEnded: 'Webinaire terminé',
    surveySent: 'Enquête envoyée',
    toConfirm: 'À confirmer',
    participantConfirmed: 'Participant confirmé',
    note: "Note",
    library: 'Bibliothèque',
    manualCoach: 'Manuel des coachs',
    manualParticipant: 'Manuel des participants',
    skipActivityReminders: 'Ignorer les rappels d\'activité',
    loginCheckManual: 'Consultez également le',
    loginManual: 'manuel',
    loginProblems: 'Vous rencontrez des problèmes ou avez des questions?',
    loginContactUs: 'Contactez-nous.',
    loginPassword: 'Mot de passe',
    loginForgotPassword: 'Mot de passe oublié?',
    loginEmailSent: 'Courriel envoyé',
    loginClickLink: 'Cliquez sur le lien dans le courriel pour vous connecter.',
    loginEmailFrom: 'Courriel provenant de : no-reply@itinera-talentcoaching.be (vérifiez également votre spam)',
    loginErrorGeneric: 'Quelque chose s\'est mal passé, veuillez réessayer.',
    loginErrorNoUser: 'Aucun utilisateur avec cette adresse e-mail n\'a été trouvé.',
    loginAccountArchived: 'Votre trajet chez Itinera est terminé et votre dossier a été clôturé. Il n\'est donc plus possible de vous connecter au Hub Itinera. Contactez votre coach si vous avez encore des questions.',
    loginLinkExpired: 'Ce lien de connexion a expiré ou a déjà été utilisé. Saisissez votre adresse e-mail ci-dessous pour recevoir un nouveau lien.',
    loginLinkWrongEmail: 'Cette adresse e-mail ne correspond pas à l\'adresse à laquelle le lien de connexion a été envoyé. Veuillez réessayer.',
    loginLinkEnterEmail: 'Confirmez votre adresse e-mail pour terminer la connexion.',
    loginLinkConfirm: 'Connexion',
    loginWrongPassword: 'Le mot de passe est incorrect.',
    programArchivedNoAccess: 'Ce dossier est archivé et n\'est plus accessible qu\'aux administrateurs.',
    backToOverview: 'Retour à l\'aperçu',
    backToHome: 'Retour à l\'accueil',
    viewAgain: 'Voir à nouveau',
    totalOverview: 'Vue d\'ensemble',
    activities: 'Activités',
    directlyCounted: 'Compté directement',
    planned: 'Planifié',
    performed: 'Réalisé',
    confirmed: 'Confirmé',
    registerForWebinar: 'S\'inscrire',
    registeredForWebinar: 'Inscrit au webinaire',
    webinarTypeExplanationOM: 'OM = Management Organisationnel\nCe webinaire s\'adresse aux participants ayant une fonction de direction, de coordination ou stratégique.',
    webinarTypeExplanationOT: 'OT = Technique Opérationnel\nCe webinaire s\'adresse aux participants ayant une fonction exécutive, technique ou opérationnelle.',
    webinarTypeExplanationQuestion: 'Vous hésitez sur l\'option qui vous convient le mieux ? N\'hésitez pas à en discuter avec votre coach.',
  },
  en: {
    coach: "Coach",
    backToHome: 'Back to Home',
    viewAgain: 'View Again',
  },
};
